import clsx from 'clsx';

import Icon from '../Icon';
import { SafeLink } from './SafeLink';

export { SafeLink } from './SafeLink';

type LinkProps = {
  url: string;
  title?: string;
  newTab?: boolean;
  external?: boolean;
  className?: string;
  activeClassName?: string;
  defaultClassName?: string;
  label?: React.ReactNode;
  children?: React.ReactNode;

  withIcon?: boolean;
  withDecoration?: boolean;
};

export const Link: React.FC<LinkProps> = ({
  url,
  label,
  title,
  newTab,
  children,
  className,
  activeClassName,
  external = false,
  defaultClassName = 'cursor-pointer',

  withIcon = false,
  withDecoration = false,
}) => {
  if (!url) return null;

  const content = children ?? label;

  return (
    <SafeLink
      to={url}
      title={title}
      newTab={newTab}
      isNav={!external}
      external={external as any}
      onClick={e => e.stopPropagation()}
      {...(activeClassName ? { activeClassName } : {})}
      className={clsx(
        defaultClassName,
        withDecoration
          ? 'border-b hover:border-main hover:text-main pr-sm border-transparent transition-default'
          : '',
        className
      )}
    >
      {withIcon ? <span className="mr-xs">{content}</span> : content}
      {!!withIcon && <Icon icon="link" />}
    </SafeLink>
  );
};
